module.exports = __webpack_public_path__ + "img/1.534c292a.png";